module.exports = __webpack_public_path__ + "johanniter-logo.svg?1c819be45f82cc7ee520338cd169b8b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/johanniter-logo.svg
// module id = 68
// module chunks = 0